module.exports = __webpack_public_path__ + "img/warning.9494f4b4.svg";